// File upload constraints (consumed by validators.validateFile + useFileUpload)
export const ALLOWED_FILE_TYPES = [
  '.csv',
  '.xlsx',
  '.xls',
  '.json',
  '.xml',
  '.txt',
];

export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

export const ITEMS_PER_PAGE = 10;

export const DATE_FORMAT = 'MMM dd, yyyy';
export const DATE_TIME_FORMAT = 'MMM dd, yyyy hh:mm a';
